document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.shopify-section--featured-collection'); // Ersetzen Sie '.collection-section' mit dem tatsächlichen Selektor Ihrer Sektionen

    sections.forEach(section => {
        const collectionNavButtons = section.querySelectorAll('.ds-collection-nav-button');
        const collectionProducts = section.querySelectorAll('.ds-featured-collection-products');
        const collectionButtons = section.querySelectorAll('.ds-featured-collection__buttons');

        function updateButtonVisibility(collectionId) {
            collectionButtons.forEach(button => {
                if (button.getAttribute('data-collection-id') === collectionId) {
                    button.style.display = 'flex';
                } else {
                    button.style.display = 'none';
                }
            });
        }

        function collectionButtonClick(event) {
            event.preventDefault();

            const clickedButton = event.currentTarget;
            const collectionId = clickedButton.getAttribute('data-collection-id');
            
            collectionNavButtons.forEach(button => {
                button.classList.add('button--secondary');
            });
            
            clickedButton.classList.remove('button--secondary');
            
            collectionProducts.forEach(collection => {
                collection.style.display = 'none';
            });
            
            const targetCollection = section.querySelector(`.ds-featured-collection-products[data-collection-id="${collectionId}"]`);
            if (targetCollection) {
                targetCollection.style.display = 'block';
            }

            updateButtonVisibility(collectionId);
        }

        collectionNavButtons.forEach(button => {
            button.addEventListener('click', collectionButtonClick);
        });

        // Initial setup
        if (collectionNavButtons.length > 0) {
            const firstButton = collectionNavButtons[0];
            firstButton.classList.remove('button--secondary');
            const initialCollectionId = firstButton.getAttribute('data-collection-id');
            
            const initialCollection = section.querySelector(`.ds-featured-collection-products[data-collection-id="${initialCollectionId}"]`);
            if (initialCollection) {
                initialCollection.style.display = 'block';
            }

            updateButtonVisibility(initialCollectionId);
        }
    });
});
